var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMilageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#0473EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408_5635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9043 19.684C16.9043 20.2884 17.396 20.7801 18.0003 20.7801C18.6047 20.7801 19.0964 20.2884 19.0964 19.684C19.0964 19.2241 18.5411 16.3105 18.0003 13.6167C17.4595 16.3105 16.9043 19.2242 16.9043 19.684Z",
    fill: "#0473EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0098 12.3882L14.499 14.8775C15.3236 14.1966 16.3492 13.7511 17.4719 13.6437V10.1257C15.4376 10.2425 13.5308 11.0323 12.0098 12.3882Z",
    fill: "#0473EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7373 13.1353L22.248 15.6245C22.9289 16.4491 23.3744 17.4747 23.4818 18.5974H26.9998C26.883 16.5631 26.0932 14.6563 24.7373 13.1353Z",
    fill: "#0473EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5273 10.1257V13.6437C19.6501 13.7511 20.6756 14.1966 21.5003 14.8775L23.9895 12.3882C22.4685 11.0323 20.5616 10.2425 18.5273 10.1257Z",
    fill: "#0473EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.895 23.0202L21.5215 23.3937L24.0022 25.8744L24.3757 25.5009C25.9535 23.9231 26.8738 21.8636 27.0007 19.6541H23.4831C23.3629 20.9257 22.8097 22.1055 21.895 23.0202Z",
    fill: "#0473EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18.5974H12.518C12.6253 17.4747 13.0709 16.4491 13.7517 15.6245L11.2625 13.1353C9.90661 14.6563 9.11678 16.5631 9 18.5974Z",
    fill: "#0473EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6249 25.5009L11.9984 25.8744L14.4792 23.3937L14.1056 23.0202C13.1909 22.1055 12.6378 20.9257 12.5175 19.6541H9C9.12682 21.8636 10.0472 23.9231 11.6249 25.5009Z",
    fill: "#0473EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_408_5635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilageIcon);
export default __webpack_public_path__ + "static/media/milage-icon.b9f38a190b9e6a598c01f38a156ed9a1.svg";
export { ForwardRef as ReactComponent };